exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skittle{position:absolute;cursor:pointer;border:1px solid #ccc}.skittle-tooltip{display:inline-block}.skittle-tooltipText{visibility:hidden;width:auto;background-color:black;font-size:12px;font-weight:600;color:#fff;text-align:center;padding:5px 3px;margin:15px 0px 0px 10px;position:absolute;z-index:1}.skittle-tooltip:hover .skittle-tooltipText{visibility:visible}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/skittlesChart/skittle.scss
// module id = 906
// module chunks = 0